import { render, staticRenderFns } from "./Streamers.vue?vue&type=template&id=7d0b0c74&scoped=true"
import script from "./Streamers.vue?vue&type=script&lang=js"
export * from "./Streamers.vue?vue&type=script&lang=js"
import style0 from "./Streamers.vue?vue&type=style&index=0&id=7d0b0c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0b0c74",
  null
  
)

export default component.exports